import type { ReactNode } from "react";
import { Link } from "react-router";
import { MarcaGeovendas } from "./MarcaGeovendas";
import { ControleDeTema } from "./ControleDeTema";

export interface PropsDaCascaPublica {
  titulo: string;
  descricao?: ReactNode;
  children: ReactNode;
  /** Linha de ações abaixo do cartão — links de recuperação, volta para a landing. */
  rodape?: ReactNode;
  /** Aparece acima do título; é onde entra o contexto de um convite, por exemplo. */
  acima?: ReactNode;
}

/**
 * Casca das telas de acesso: uma coluna estreita e centrada, sem navegação.
 * Não há nada para explorar aqui — a página tem uma tarefa só, e tirar a navegação do
 * caminho é o que deixa isso evidente.
 */
export function CascaPublica({
  titulo,
  descricao,
  children,
  rodape,
  acima,
}: PropsDaCascaPublica) {
  return (
    <div className="acesso">
      <header className="acesso__topo">
        <div className="acesso__topo-interno">
          <Link to="/" className="acesso__marca" aria-label="Início do portal">
            <MarcaGeovendas />
          </Link>
          <ControleDeTema />
        </div>
      </header>

      <main className="acesso__centro">
        <div className="acesso__coluna">
          {acima}
          <section className="acesso__cartao">
            <h1 className="acesso__titulo">{titulo}</h1>
            {descricao ? <p className="acesso__descricao">{descricao}</p> : null}
            {children}
          </section>
          {rodape ? <div className="acesso__rodape">{rodape}</div> : null}
        </div>
      </main>

      <footer className="acesso__nota">
        {/* Sem utilitária de margem aqui: a folha de estilo centra este parágrafo com
            `margin: 0 auto`, e uma utilitária do Tailwind (camada posterior) venceria a
            regra, jogando a nota para a borda esquerda da janela. */}
        <p className="nota-rodape">
          Portal de Implantação GEOvendas · o acesso é criado pela GEOvendas e chega por
          convite nominal. A GEOvendas nunca pede a sua senha por e-mail, telefone ou
          mensagem.
        </p>
      </footer>
    </div>
  );
}
